export default __webpack_public_path__ + "static/media/whitelogo.cacec395.png";